var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.00679 0C4.56208 0 0.958496 3.60358 0.958496 8.0483C0.958496 12.0648 3.90125 15.3939 7.74952 16V10.3753H5.70505V8.0483H7.74952V6.27508C7.74952 4.25636 8.95125 3.14317 10.7889 3.14317C11.6694 3.14317 12.5919 3.30013 12.5919 3.30013V5.2794H11.5745C10.5764 5.2794 10.2641 5.90079 10.2641 6.53748V8.04669H12.4945L12.1379 10.3737H10.2641V15.9984C14.1123 15.3955 17.0551 12.0656 17.0551 8.0483C17.0551 3.60358 13.4515 0 9.00679 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.e51baffeee1024f36a8f52b983c18051.svg";
export { ForwardRef as ReactComponent };